import { render, staticRenderFns } from "./widgetBulkSelector.vue?vue&type=template&id=488e832e&scoped=true"
import script from "./widgetBulkSelector.vue?vue&type=script&lang=js"
export * from "./widgetBulkSelector.vue?vue&type=script&lang=js"
import style0 from "./widgetBulkSelector.vue?vue&type=style&index=0&id=488e832e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e832e",
  null
  
)

export default component.exports